if (!customElements.get('albealand-vineyard-map')) {
  class AlbealandVineyardMap extends HTMLElement {
    constructor() {
      super();
      this.activeId = null;
    }

    connectedCallback() {
      this.hotspots = this.querySelectorAll('.albealand-vineyards-map__hotspot');
      this.cards = this.querySelectorAll('.albealand-vineyards-map__card');

      this.handleDocumentClick = this.handleDocumentClick.bind(this);
      this.handleKeyDown = this.handleKeyDown.bind(this);

      this.hotspots.forEach((hotspot) => {
        const id = hotspot.dataset.hotspotId;

        hotspot.addEventListener('click', (event) => {
          event.stopPropagation();
          this.toggle(id);
        });

        hotspot.addEventListener('mouseenter', () => this.preview(id));
        hotspot.addEventListener('mouseleave', () => this.hidePreview(id));
        hotspot.addEventListener('focus', () => this.preview(id));
        hotspot.addEventListener('blur', () => this.hidePreview(id));
      });

      document.addEventListener('click', this.handleDocumentClick);
      document.addEventListener('keydown', this.handleKeyDown);
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.handleDocumentClick);
      document.removeEventListener('keydown', this.handleKeyDown);
    }

    handleDocumentClick(event) {
      if (!this.contains(event.target)) {
        this.closeAll();
      }
    }

    handleKeyDown(event) {
      if (event.key === 'Escape' && this.activeId) {
        this.closeAll();
      }
    }

    toggle(id) {
      if (this.activeId === id) {
        this.closeAll();
        return;
      }
      this.closeAll();
      const card = this.querySelector('[data-card-id="' + id + '"]');
      const hotspot = this.querySelector('[data-hotspot-id="' + id + '"]');
      if (card) {
        card.classList.add('is-open');
        this.activeId = id;
      }
      if (hotspot) {
        hotspot.setAttribute('aria-expanded', 'true');
      }
    }

    preview(id) {
      if (this.activeId) return;
      const card = this.querySelector('[data-card-id="' + id + '"]');
      if (card) card.classList.add('is-preview');
    }

    hidePreview(id) {
      const card = this.querySelector('[data-card-id="' + id + '"]');
      if (card) card.classList.remove('is-preview');
    }

    closeAll() {
      this.cards.forEach((c) => c.classList.remove('is-open', 'is-preview'));
      this.hotspots.forEach((h) => h.setAttribute('aria-expanded', 'false'));
      this.activeId = null;
    }
  }

  customElements.define('albealand-vineyard-map', AlbealandVineyardMap);
}
